import c from "./constant";

export const setDeductions = deductions => ({
  type: c.SET_DEDUCTIONS,
  deductions
});

export const clearDeductions = () => ({
  type: c.CLEAR_DEDUCTIONS,
});
